<template>
  <div class="cart-list-wrap" id="cartBox">
    <div class="cart-header flex-between" id="cartHeader">
      <p class="cart-title">{{ cartTitle }}</p>
      <Icon
        class="cart-detail-down j-click-close-cart"
        name="down"
        @click="close"
      ></Icon>
    </div>

    <div class="product-wrap">
      <div class="product-box" id="cartProductList">
        <div
          class="product-item"
          v-for="(item, index) in cartList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID"
        >
          <div class="detail-wrap">
            <div class="left">
              <gift-icon
                class="product-icon"
                background=""
                :gifts="getGiftIcons(item)"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="tag-wrap">
                <span class="product-tag" v-if="extraTip(item)">
                  {{ extraTip(item) }}
                </span>
                <span class="product-tag" v-if="+item.COUPON">{{
                  letter.couponCanUseQuan
                }}</span>
              </div>
              <div class="top-bar flex-between">
                <div>
                  <p class="product-name name">
                    {{ getProductName(item) }}
                  </p>
                  <p class="product-desc name">
                    {{ getProductDetail(item) }}
                  </p>
                </div>
                <Icon
                  class="remove-ico"
                  name="close"
                  @click="doRemoveProduct(item, index)"
                ></Icon>
              </div>
              <div class="cart-bar">
                <div class="quantity">
                  <span
                    class="quantity-item action flex-center j-click-sub-to-cart-cart-list"
                    @click="doSubProduct(item, index)"
                  >
                    <Icon class="action-ico" name="minus"></Icon>
                  </span>
                  <span class="quantity-item total">{{ item.quantity }}</span>
                  <span
                    class="quantity-item action flex-center j-click-add-to-cart-cart-list"
                    @click="addToCart(item)"
                  >
                    <Icon class="action-ico" name="plus"></Icon>
                  </span>
                </div>
                <div
                  class="product-price"
                  v-if="
                    item.amountLevel &&
                    item.amountLevel.TRANS_AMOUNT &&
                    item.amountLevel.SHOW_CURRENCY
                  "
                >
                  {{ item.amountLevel.TRANS_AMOUNT }}
                  {{ item.amountLevel.SHOW_CURRENCY }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product-summary" id="cartSummary">
      <div class="summary-bar flex-between">
        <p>{{ letter.v3ItemPrice }}:</p>
        <p class="bold">{{ cartTotalPrice }} {{ currency }}</p>
      </div>
      <div v-if="isShowTax" class="summary-bar flex-between">
        <p>{{ letter.v3Tax }}：</p>
        <p class="bold">{{ curTax }} {{ currency }}</p>
      </div>
      <div class="submit-bar flex-between">
        <div>
          <p>{{ letter.v3Total }}</p>
          <p class="total-price">{{ realPrice }} {{ currency }}</p>
        </div>
        <button class="submit-btn flex-center" @click="submitCart">
          {{ letter.select_paytype }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { b64EncodeUnicode } from '@utiles/officialStore';
import { mapState, mapGetters } from 'vuex';
import selectContainer from '@mixins/officialTopup/selectContainer';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import product from '@mixins/officialTopup/product';
import productName from '@mixins/product';
import extra from '@mixins/officialTopup/extra';

export default {
  mixins: [selectContainer, cartAddAndDetail, product, productName, extra],
  data() {
    return {
      currency: ''
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    ...mapGetters([
      'cartTotalPrice',
      'cartTotalExtraCoin',
      'cartTotalQuantity',
      'cartDiscountTransMount',
      'cartProductType',
      'getPointPayChannelName',
      'extraCoinName'
    ]),
    cartTitle() {
      return this.letter?.v3SelectedItemsN.replace(
        '${n}',
        this.cartTotalQuantity
      );
    }
  },
  watch: {
    paytype: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal?.show_currency) {
          this.currency = newVal?.show_currency;
        }
      }
    }
  },
  mounted() {
    this.setCartListHeight();
  },
  methods: {
    // 兼容一下中间区域高度
    setCartListHeight() {
      const total = document.getElementById('cartBox');
      const header = document.getElementById('cartHeader');
      const content = document.getElementById('cartProductList');
      const summary = document.getElementById('cartSummary');
      const contentHeight =
        total.offsetHeight - header.offsetHeight - summary.offsetHeight + 1;
      content.style.height = `${contentHeight}px`;
    },
    getCartListParam() {
      return this.cartList.map(item => {
        return {
          productId: item.PRODUCT_ID,
          cpProductId: item.CP_PRODUCT_ID,
          remark: item.REMARK || '',
          amount: item.amountLevel.TRANS_AMOUNT || '',
          quantity: item.quantity,
          productDesc: item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '',
          cpProductExt: item.CP_PRODUCT_EXT || {}
        };
      });
    },
    sendCheckCartData() {
      window.webstorev3DataLayer.push({
        eventName: 'check_cart',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_num: this.cartList.length,
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_currency: this.currency,
          product_money: this.cartTotalPrice
        }
      });
    },
    submitCart() {
      this.$emit('submitCart');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
@import '@assets/scss/officialTopup/_dimen.scss';

.cart-list-wrap {
  position: absolute;
  bottom: 140px;
  width: 100%;
  // height: 70vh;
  max-height: 70vh;
  // min-height: 730px;
  box-sizing: border-box;
  border-radius: 20px;
  background-color: $backgroundColor;
  color: #333333;
  display: flex;
  flex-direction: column;

  .cart-header {
    @include g-popup-title();
    border-radius: 20px 20px 0 0;
    padding: 40px;
    flex-shrink: 0;
    .cart-title {
      font-size: 28px;
    }
    .cart-detail-down {
      cursor: pointer;
      flex-shrink: 0;
      margin-left: 10px;
      width: 38px;
      height: 38px;
    }
  }
}
.product-wrap {
  padding: 0 30px;
  .product-box {
    max-height: 40vh;
    height: 757px;
    overflow-y: scroll;
    padding: 0 10px;
    scrollbar-width: 1px !important;
    .product-item {
      background-color: #ffffff;
      border-radius: 20px;
      box-sizing: border-box;
      padding: 20px;
      margin-bottom: 20px;
      .tag-wrap {
        margin-bottom: 10px;
        line-height: 1.5;
        .product-tag {
          font-size: 20px;
          padding: 0 20px;
          @include g-gradient-btn();
          background-blend-mode: normal, normal;
          border-radius: 16px 0px 16px 0px;
        }
        .product-tag + .product-tag {
          margin-left: 10px;
        }
      }
      .detail-wrap {
        display: flex;
        align-items: center;
        .left {
          margin-left: 10px;
          width: 92px;
          transform: scale(0.5);
          .product-icon {
            width: 92px;
            height: auto;
          }
        }
        .right {
          margin-left: 64px;
          flex: 1;
          word-break: break-word;
          .top-bar {
            line-height: 1.5;
            .product-name {
              font-size: 22px;
              line-height: 1.2;
            }
            .product-desc {
              font-size: 20px;
              color: #999999;
            }
            .remove-ico {
              flex-shrink: 0;
              width: 45px;
              height: 38px;
              cursor: pointer;
            }
          }
          .cart-bar {
            margin-top: 16px;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            .quantity {
              height: 40px;
              display: flex;
              align-items: center;
              border-radius: 6px;
              border: 1px solid #d2d1d1;

              .quantity-item {
                font-size: 20px;
                font-weight: bold;

                &.action {
                  width: 40px;
                  height: 40px;
                  cursor: pointer;

                  .action-ico {
                    width: 22px;
                    height: 22px;
                  }
                }
                &.total {
                  display: inline-block;
                  min-width: 40px;
                  height: 100%;
                  line-height: 40px;
                  text-align: center;
                  border-left: 1px solid #d2d1d1;
                  border-right: 1px solid #d2d1d1;
                }
              }
            }
            .product-price {
              font-size: 24px;
              color: $themeColor;
            }
          }

          .quantity {
            .quantity-item {
              &.action {
                width: 50px;
              }
            }
          }
        }
      }
    }
  }
}

.product-summary {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 40px;
  background-color: #ffffff;

  .summary-bar {
    line-height: 1.2;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .submit-bar {
    line-height: 1.2;
    font-size: 24px;
    margin-bottom: 10px;
    align-items: flex-end;
    .total-price {
      margin-top: 20px;
      font-size: 30px;
      font-weight: bold;
      line-height: 1.2;
      color: $themeColor;
    }
    .submit-btn {
      font-size: 26px;
      min-width: 256px;
      background-color: $themeColor;
      padding: 10px 20px;
      border-radius: 9px;
      color: #ffffff;
    }
  }
}

@media screen and (orientation: landscape) {
  .cart-list-wrap {
    max-height: unset;
    bottom: 60px;

    .cart-header {
      .cart-title {
        font-size: 24px;
      }
      .cart-detail-down {
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
    }
  }
  .product-wrap {
    height: 367px;
    .product-box {
      max-height: unset;
      height: 360px;
      .product-item {
        padding: 24px;
        margin-bottom: 10px;
        .tag-wrap {
          .product-tag {
            font-size: 18px;
          }
        }
        .detail-wrap {
          .left {
            width: 80px;
            // height: 80px;
            transform: scale(0.4);
            .product-icon {
              width: 80px;
              height: auto;
            }
          }
          .right {
            margin-left: 24px;
            .top-bar {
              .product-name {
                font-size: 18px;
              }
              .product-desc {
                font-size: 16px;
              }
              .remove-ico {
                width: 24px;
                height: 24px;
              }
            }
          }
        }
      }
    }
  }
  .product-summary {
    .summary-bar {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .submit-bar {
      font-size: 20px;
      margin: 20px 0;
      .total-price {
        margin-top: 0;
        font-size: 26px;
      }
      .submit-btn {
        font-size: 26px;
        min-width: 216px;
        height: 49px;
      }
    }
  }
  .submit-btn {
    display: none;
  }
}
</style>
